import React from 'react'
import { compose, withBeacon, withTranslation, connect } from '@hocs'

import { feedbackUrl } from '@libs/appUrl'
import { trackingShareProperty } from '@app-core/beacon/beacon'

import { openConfirmDialog } from '@app-core/app/actions'

import SlideUpModal from '@components/SlideUpModal'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import { isSecretClas } from '@libs/postTools'
import styles from './index.scss'
import GaEventFactory from './GaEventFactory'
import { OptionMenuUIEvents, dispatchEvent, dispatchCustomEvent } from '@libs/customEvents'

class OptionMenu extends React.PureComponent {
  static defaultProps = {
    hide: {
      sanction: true,
    },
    isReplyAuthor: false,
  }

  render() {
    const {
      t,
      isOpen,
      handleClose,
      sharePost,
      shareType,
      deleteType,
      reportType,
      url,
      userId,
      hide,
      onClickEdit,
      onClickDelete,
      onClickBlock,
      amplitudeEventTrack,
      isAdmin,
      isReplyAuthor,
    } = this.props

    const isSecret = isSecretClas(sharePost.get('clas'))
    const isAuthor =
      sharePost.getIn(['userInfo', 'owner']) || userId === sharePost.getIn(['userInfo', 'mid'])

    const options = {
      share: [
        {
          key: 'facebook',
          onClick: this._shareFB,
          check: true,
        },
        {
          key: 'messenger',
          onClick: this._shareMessenger,
          check: true,
        },
        {
          key: 'line',
          onClick: this._shareLINE,
          check: true,
        },
      ],
      more: [
        {
          key: 'edit',
          onClick: onClickEdit,
          check: !isSecret && isAuthor && onClickEdit,
        },
        {
          key: 'delete',
          onClick: this._onClickDelete,
          check:
            deleteType === 'reply' ? isReplyAuthor && onClickDelete : isAuthor && onClickDelete,
        },
        {
          key: 'report',
          onClick: this._report,
          check:
            amplitudeEventTrack && this._report && reportType === 'reply'
              ? !isReplyAuthor
              : !isAuthor,
        },
        {
          key: 'block',
          onClick: onClickBlock,
          check: onClickBlock,
        },
        {
          key: 'feedback',
          onClick: this._feedback,
          check: shareType === 'place' && amplitudeEventTrack && this._feedback,
        },
        {
          key: 'sanction',
          onClick: this._sanction,
          check: this._sanction,
        },
      ],
      admin: [
        {
          key: 'recall',
          onClick: this._recall,
          check: isAdmin,
        },
      ],
    }

    return (
      <SlideUpModal isOpen={isOpen} handleClose={handleClose}>
        <style jsx>{styles}</style>
        <div className="optionMenu">
          <div className="optionMenu__content">
            <div className="optionMenu__section optionMenu__section--sns" data-title={t('share')}>
              {options.share.map((option) => this._renderOption('share', option))}
            </div>
            <div className="optionMenu__section optionMenu__section--more" data-title={t('more')}>
              {!hide.copylink && (
                <CopyToClipboard text={url} onCopy={this._onCopy}>
                  <div className="optionMenu__item optionMenu__item--copylink">
                    {t('more_copylink')}
                  </div>
                </CopyToClipboard>
              )}
              {options.more.map((option) => this._renderOption('more', option))}
              {options.admin.map((option) => this._renderOption('admin', option))}
            </div>
          </div>
          <div className="optionMenu__btn" onClick={handleClose}>
            {t('close')}
          </div>
        </div>
      </SlideUpModal>
    )
  }

  _onClickDelete = async () => {
    const detail = await this.props?.onClickDelete()
    dispatchCustomEvent(OptionMenuUIEvents.DELETE, detail)
  }

  _renderOption = (type, { key, onClick, check }) => {
    const { hide, t } = this.props
    return (
      !hide[key] &&
      check && (
        <div key={key} className={`optionMenu__item optionMenu__item--${key}`} onClick={onClick}>
          <style jsx>{styles}</style>
          {t(`${type}_${key}`)}
        </div>
      )
    )
  }

  sharePostTrack = (via = '') => {
    const { sharePost } = this.props
    const extProperties = {}
    if (via) extProperties['share-via'] = via
    const properties = trackingShareProperty(this.props.sharePost, extProperties)
    this.props.amplitudeEventTrack('share', properties)

    // send GA event
    const postID = sharePost.get('postID') || sharePost.postID
    const gaEvent = GaEventFactory.createShareEvent(via, postID)
    this.props.gtmEventTrack('share', gaEvent)
  }

  _onCopy = () => {
    this.sharePostTrack('link')
    dispatchEvent(OptionMenuUIEvents.COPY_LINK)
    window.alert(this.props.t('alert_copy'))
  }

  _shareFB = () => {
    this.sharePostTrack('facebook')
    dispatchCustomEvent(OptionMenuUIEvents.SHARE, { shareTo: 'facebook' })
    const [url, title] = [window.location.href, window.document.title]
    const addThisUrl = `https://www.addthis.com/bookmark.php?v=300&winname=addthis&pub=ra-5a606bcb2740770f&source=smlsh-1.0&lng=zh&s=facebook&wid=0l1e&url=${encodeURIComponent(
      url,
    )}&title=${encodeURIComponent(title)}`
    if (window.RNApp && window.RNApp.FacebookShareDialog) {
      window.RNApp.FacebookShareDialog({ url, title })
    } else if (window.RNApp && window.RNApp.openBrowser) {
      window.RNApp.openBrowser(addThisUrl)
    } else {
      window.open(addThisUrl)
    }
  }

  _shareMessenger = () => {
    this.sharePostTrack('messenger')
    dispatchCustomEvent(OptionMenuUIEvents.SHARE, { shareTo: 'messenger' })
    const [url, title] = [window.location.href, window.document.title]
    const addThisUrl = `https://www.addthis.com/bookmark.php?v=300&winname=addthis&pub=ra-5a606bcb2740770f&source=smlsh-1.0&lng=zh&s=messenger&wid=s1p4&url=${encodeURIComponent(
      url,
    )}&title=${encodeURIComponent(title)}`
    if (window.RNApp && window.RNApp.openBrowser) {
      window.RNApp.openBrowser(addThisUrl)
    } else {
      window.open(addThisUrl)
    }
  }

  _shareLINE = () => {
    this.sharePostTrack('line')
    dispatchCustomEvent(OptionMenuUIEvents.SHARE, { shareTo: 'line' })
    const [url, title] = [window.location.href, window.document.title]
    const addThisUrl = `https://www.addthis.com/bookmark.php?v=300&winname=addthis&pub=ra-5a606bcb2740770f&source=smlsh-1.0&lng=zh&s=lineme&wid=s1p4&url=${encodeURIComponent(
      url,
    )}&title=${encodeURIComponent(title)}`
    if (window.RNApp && window.RNApp.openBrowser) {
      window.RNApp.openBrowser(addThisUrl)
    } else {
      window.open(addThisUrl)
    }
  }

  _feedback = () => {
    const { url, userId, sharePost, amplitudeEventTrack } = this.props
    amplitudeEventTrack('report.wrong.info', trackingShareProperty(sharePost))
    window.open(feedbackUrl({ url, userId }))
  }

  _report = () => {
    const {
      shareType,
      sharePost,
      onClickReport,
      openConfirmDialog,
      t,
      amplitudeEventTrack,
      postID,
      replyID,
      text,
    } = this.props
    openConfirmDialog({
      title: t('confirmReport', { type: t(`type_${shareType}`) }),
      onSure: () => {
        dispatchEvent(OptionMenuUIEvents.REPORT)
        amplitudeEventTrack(`report.${shareType}`, trackingShareProperty(sharePost))
        if (postID && replyID && text) {
          onClickReport(postID, replyID, text)
        } else {
          onClickReport()
        }
      },
    })
  }

  _recall = () => {
    const {
      recallPost,
      recallReply,
      t,
      recallType,
      openConfirmDialog,
      replyID,
      handleClose,
    } = this.props

    // close OptionMenu
    handleClose()

    openConfirmDialog({
      title: t('confirmRecall', { type: t(`type_${recallType}`) }),
      onSure: () => {
        replyID ? recallReply(replyID) : recallPost()
      },
    })
  }
}

const mergeProps = (state, dispatchProps, ownProps) => {
  let { hide } = ownProps
  if (Array.isArray(hide)) hide = hide.reduce((obj, p) => ((obj[p] = true), obj), {})
  return {
    ...state,
    ...dispatchProps,
    ...ownProps,
    hide,
  }
}

export default compose(
  withBeacon,
  withTranslation('optionMenu'),
  connect(null, { openConfirmDialog }, mergeProps),
)(OptionMenu)
